// Global
import React from 'react';

// Local
import { HeroProps } from '../Hero';

export const HeroArticle = (_props: HeroProps) => {
  /*
   * Rendering
   */

  return <div>Hero article</div>;
};
